import React from 'react'
import classes from './SubHeader.module.css';

const SubHeader = () => {
  return (
    <div className={classes.title_container}>
        <div className={classes.title}>
            Similar Videos
        </div>
    </div>
  )
}

export default SubHeader